export const DEFAULT_ERROR_TEXT = 'Поле заполнено неккоректно';
